import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { ListagemProvider } from 'context/ListagemContext';
import { ConsultaReembolsoProdutoGrid } from 'pages/financeiro/reembolso/consulta-reembolso/components';
import { useQueryConsultaReembolso } from 'pages/financeiro/reembolso/consulta-reembolso/hooks';
import { ConsultaReembolso } from 'pages/financeiro/reembolso/consulta-reembolso/types';
import { brlDate, brlPrice } from 'util/format';

/**
 * Retorna array com os dados formatados para o grid.
 */
const getRows = (data?: ConsultaReembolso[]): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item) => ({
            id: `${item.nrNota}-${item.dsSerie}`,
            nrNota: item.nrNota,
            dsSerie: item.dsSerie,
            dtEmissao: item.dtEmissao,
            cdLoja: item.cdLoja,
            dsNomeFantasia: item.dsNomeFantasia,
            dsTipoNota: item.dsTipoNota,
            vlDesconto: item.vlDesconto,
            vlDescontoManual: item.vlDescontoManual,
            vlTotalLiquido: item.vlTotalLiquido,
            vlTotalBruto: item.vlTotalBruto,
            vlReembolso: item.vlReembolso,
        }));
    }

    return [];
};

const columns: GridColDef[] = [
    {
        field: 'nrNota',
        headerName: 'Número nota/série',
        maxWidth: 120,
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => `${row.nrNota} / ${row.dsSerie}`,
    },
    {
        field: 'dtEmissao',
        align: 'center',
        headerAlign: 'center',
        headerName: 'Emissão',
        width: 120,
        valueFormatter: (value) => brlDate(`${value}T00:00:00`),
    },
    {
        field: 'cdLoja',
        headerName: 'Loja',
        flex: 1,
        renderCell: ({ row }) => `${row.dsNomeFantasia}`,
    },
    {
        field: 'dsTipoNota',
        headerName: 'Tipo da nota',
        renderCell: ({ row }) => `${row.dsTipoNota}`,
        flex: 1,
        width: 140,
    },
    {
        field: 'vlTotalBruto',
        headerName: 'Valor bruto',
        type: 'number',
        width: 140,
        valueFormatter: (value) => brlPrice(value),
    },
    {
        field: 'vlDesconto',
        headerName: 'Valor desconto',
        type: 'number',
        width: 130,
        valueFormatter: (value) => brlPrice(value),
    },
    {
        field: 'vlDescontoManual',
        headerName: 'Valor desconto manual',
        type: 'number',
        width: 130,
        valueFormatter: (value) => brlPrice(value),
    },
    {
        field: 'vlTotalLiquido',
        headerName: 'Valor líquido',
        type: 'number',
        width: 140,
        valueFormatter: (value) => brlPrice(value),
    },
    {
        field: 'vlReembolso',
        headerName: 'Valor reembolso',
        type: 'number',
        width: 140,
        valueFormatter: (value) => brlPrice(value),
    },
];

export function ConsultaReembolsoGrid() {
    const { data, refetch, isFetching } = useQueryConsultaReembolso();

    return (
        <Block>
            <PanelGrid
                isTreeData
                hasNext={data?.hasNext}
                rows={getRows(data?.data)}
                rowsCount={data?.total || -1}
                reload={refetch}
                columns={columns}
                loading={isFetching}
                summary={['vlDesconto', 'vlDescontoManual', 'vlTotalBruto', 'vlTotalLiquido', 'vlReembolso']}
                getDetailPanelHeight={() => 'auto'}
                getDetailPanelContent={({ row }) => (
                    <ListagemProvider>
                        <ConsultaReembolsoProdutoGrid nrNota={row.nrNota} dsSerie={row.dsSerie} cdLoja={row.cdLoja} />
                    </ListagemProvider>
                )}
            />
        </Block>
    );
}
